import React, { useContext } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useTheme } from 'ThemeContext';
import { AppSettingsContext } from 'AppSettingsContext';

import { Wrapper, Item, Text, Icon } from './WidgetDisabledFacilities.style';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-regular-svg-icons';

import CustomFontIcon from './CustomFaIcon/CustomFontIcon';

function WidgetDisabledFacilities({
  isToolbar = false,
  themeOverride,
  data = {}
}) {
  console.log('themeOverride: ', themeOverride);
  const [appSettings, appSettingsDispatch] = useContext(AppSettingsContext);
  const intl = useIntl();
  const theme = useTheme();
  const renderItemsInner = () => {
    return (
      <>
        <Item
          href='#'
          aria-label={intl.formatMessage({
            id: 'WIDGET_DISABLED_FACITILITIES.TOGGLE_HIGH_CONTRAST'
          })}
          theme={
            (themeOverride && themeOverride.item) ||
            theme.widgetDisabledFacilities.item
          }
          size={data.size}
          title={intl.formatMessage({
            id: 'WIDGET_DISABLED_FACITILITIES.TOGGLE_HIGH_CONTRAST'
          })}
          onClick={() => {
            appSettingsDispatch({ type: 'TOGGLE_HIGH_CONTRAST' });
          }}
          active={appSettings.highContrast}
        >
          <Icon size={data.size}>
            <FontAwesomeIcon icon={faEye} />
          </Icon>
          <Text>
            <FormattedMessage
              id={'WIDGET_DISABLED_FACITILITIES.HIGH_CONTRAST'}
            />
          </Text>
        </Item>
        <Item
          aria-label={intl.formatMessage({
            id: 'WIDGET_DISABLED_FACITILITIES.REDUCE_FONT_SIZE'
          })}
          href='#'
          theme={
            (themeOverride && themeOverride.item) ||
            theme.widgetDisabledFacilities.item
          }
          size={data.size}
          title={intl.formatMessage({
            id: 'WIDGET_DISABLED_FACITILITIES.REDUCE_FONT_SIZE'
          })}
          onClick={() => {
            appSettingsDispatch({ type: 'REDUCE_FONT_SIZE' });
          }}
        >
          <Icon size={data.size}>
            <FontAwesomeIcon icon={CustomFontIcon} />
            <FontAwesomeIcon icon={faMinus} size={'xs'} />
          </Icon>
        </Item>
        <Item
          aria-label={intl.formatMessage({
            id: 'WIDGET_DISABLED_FACITILITIES.RESET_FONT_SIZE'
          })}
          href='#'
          theme={
            (themeOverride && themeOverride.item) ||
            theme.widgetDisabledFacilities.item
          }
          size={data.size}
          title={intl.formatMessage({
            id: 'WIDGET_DISABLED_FACITILITIES.RESET_FONT_SIZE'
          })}
          onClick={() => {
            appSettingsDispatch({ type: 'RESET_FONT_SIZE' });
          }}
        >
          <Icon size={data.size}>
            <FontAwesomeIcon icon={CustomFontIcon} />
          </Icon>
        </Item>
        <Item
          aria-label={intl.formatMessage({
            id: 'WIDGET_DISABLED_FACITILITIES.INCREASE_FONT_SIZE'
          })}
          href='#'
          theme={
            (themeOverride && themeOverride.item) ||
            theme.widgetDisabledFacilities.item
          }
          size={data.size}
          title={intl.formatMessage({
            id: 'WIDGET_DISABLED_FACITILITIES.INCREASE_FONT_SIZE'
          })}
          onClick={() => {
            appSettingsDispatch({ type: 'INCREASE_FONT_SIZE' });
          }}
        >
          <Icon size={data.size}>
            <FontAwesomeIcon icon={CustomFontIcon} />
            <FontAwesomeIcon icon={faPlus} size={'xs'} />
          </Icon>
        </Item>
      </>
    );
  };

  return (
    <>
      {isToolbar ? (
        renderItemsInner()
      ) : (
        <Wrapper theme={theme.widgetDisabledFacilities.wrapper}>
          {renderItemsInner()}
        </Wrapper>
      )}
    </>
  );
}

export default WidgetDisabledFacilities;
